import React from 'react';
import './Expirence.css';

const Expirence = () => {
  return (
    <div>
      <div className="exp">
        <div className="exp-title">Experience</div>

        <div className="work">
          <img
            src={`${process.env.PUBLIC_URL}/Icons/mobitouch.png`}
            alt="Mobitouch"
          />
          <h1>Mobitouch</h1>
          <p>Backend developer in .NET</p>
          <p>07.2025 - 11.2025</p>
          <hr />

          <img
            src={`${process.env.PUBLIC_URL}/Icons/techtop.svg`}
            alt="Techtop Łukasz Mazur"
          />
          <h1>Techtop Łukasz Mazur</h1>
          <p>Computer service technician</p>
          <p>06.2024 - 09.2024</p>
          <hr />

          <img
            src={`${process.env.PUBLIC_URL}/Icons/arivi.png`}
            alt="ARIVI sp.z o.o."
          />
          <h1>ARIVI sp.z o.o.</h1>
          <p>Backend developer in Java</p>
          <p>07.2023 - 06.2024</p>
          <hr />
        </div>


        <div className="edu">
          <div className="edu-title">Education</div>
          <img
            src={`${process.env.PUBLIC_URL}/Icons/wsiiz.jpeg`}
            alt="UITM Rzeszów, Poland"
          />
          <h1>UITM Rzeszów, Poland</h1>
          <p>Cybersecurity, Master's Degree</p>
          <p>04.2026 - Present</p>
          <hr />
          <img
            src={`${process.env.PUBLIC_URL}/Icons/wsiiz.jpeg`}
            alt="UITM Rzeszów, Poland"
          />
          <h1>UITM Rzeszów, Poland</h1>
          <p>Computer Science, Engineering Degree</p>
          <p>10.2022 - 03.2026</p>
          <hr />
        </div>
        
      </div>
    </div>
  );
};

export default Expirence;
